import { ImageWithFallback } from "@/components/image/ImageWithFallback"
import { Heading, Icon, InteractiveCard, Text } from "@/components/ui"
import type { PrizeChoice } from "@/domain/marketing/prize-offer"
import { Chevron } from "@/icons"
import { useId } from "react"

type PrizeChoiceListProps = {
  choices: readonly PrizeChoice[]
  tone: "game" | "store"
  onChoose: (choice: PrizeChoice) => void
}

const LOOK = {
  game: { card: "game", caret: "game-accent" },
  store: { card: "outline", caret: "primary" },
} as const

/** The products a free-item prize can be spent on, one tap each; prices stay out because the bag shows what the coupon takes off. */
export function PrizeChoiceList({ choices, tone, onChoose }: PrizeChoiceListProps) {
  const titleId = useId()
  const look = LOOK[tone]
  return (
    <section aria-labelledby={titleId} className="flex flex-col gap-2 text-left">
      <div>
        <Heading id={titleId} level={3} size="card">
          Escolha seu prêmio
        </Heading>
        <Text size="sm" tone="muted">
          O item entra na sacola com o prêmio aplicado.
        </Text>
      </div>
      <ul className="flex max-h-72 flex-col gap-2 overflow-y-auto">
        {choices.map((choice) => (
          <li key={choice.offer.id}>
            <InteractiveCard variant={look.card} interaction="outline" padding="xs" onClick={() => onChoose(choice)} className="flex w-full items-center gap-3">
              <span aria-hidden className="h-12 w-12 shrink-0 overflow-hidden rounded-control">
                <ImageWithFallback width={96} height={96} alt="" src={choice.item.image?.URL} fit="contain" className="h-full w-full" />
              </span>
              <span className="flex min-w-0 flex-1 flex-col">
                <Text as="span" size="sm" weight="bold" truncate>
                  {choice.item.name}
                </Text>
                {choice.needsOptions ? (
                  <Text as="span" size="xs" tone="muted">
                    Tem opções para escolher
                  </Text>
                ) : null}
              </span>
              <Icon as={Chevron} size="sm" weight="bold" tone={look.caret} />
            </InteractiveCard>
          </li>
        ))}
      </ul>
    </section>
  )
}
